var _rect, _circle, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSecurity(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 14.5,
    width: 42,
    height: 32,
    fill: "#0052FF"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 19,
    cy: 14.5,
    r: 13,
    fill: "#D9D9D9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19 27.5C26.1797 27.5 32 21.6797 32 14.5H6C6 21.6797 11.8203 27.5 19 27.5Z",
    fill: "#0A0B0D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M46 25.5V24.5H45H34C30.6863 24.5 28 27.1863 28 30.5C28 33.8137 30.6863 36.5 34 36.5H45H46V35.5V25.5Z",
    stroke: "white",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M37 30.5C37 31.6046 36.1046 32.5 35 32.5C33.8954 32.5 33 31.6046 33 30.5C33 29.3954 33.8954 28.5 35 28.5C36.1046 28.5 37 29.3954 37 30.5Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecurity);
export default __webpack_public_path__ + "static/media/security.afefca653c6db58c4e3cf115bd9c51f4.svg";
export { ForwardRef as ReactComponent };